import { isNull, isUndefined } from "../../util/TypeUtil";
import Content from "./Content";
import ContentFactory from "./ContentFactory";
import MCOptionScore from "./MCOptionScore";

/**
* MCOption.js
* 
* Created on Nov 7, 2013, 12:02:41 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
export default class MCOption extends Content {
    constructor(languagePack, contentID, description, value, variable, scores) {
        super(MCOption.NAME, MCOption.TYPE, null, languagePack, contentID);

        this._description = !isUndefined(description) ? description : null;
        this._value = !isUndefined(value) ? value : null;
        this._variable = !isUndefined(variable) ? variable : null;
        this._scores = !isUndefined(scores) ? scores : [];
    }

    getDescription() {
        return this._description;
    }

    getValue() {
        return this._value;
    }

    getVariable() {
        return this._variable;
    }

    getScores() {
        return this._scores;
    }

    convertToObject() {
        const result = super.convertToObject();
        let numScores;
        let index;
        let objectScores;

        if (!isNull(this._description)) {
            result.description = this._description.convertToObject();
        }

        if (!isNull(this._value)) {
            result.value = this._value;
        }

        result.variable = this._variable;
        numScores = this._scores.length;

        objectScores = [];
        for (index = 0; index < numScores; index++) {
            objectScores[i] = { variable: this._scores[index].getVariable(), addition: this._scores[index].getAddition() };
        }
        result.scores = objectScores;

        return result;
    }

    setPropertiesFromObject(object) {
        let numScores;
        let index;
        if (!isNull(object.description)) {
            this._description = ContentFactory.getContentFromObject(object.description, this._languagePack);
            delete object.description;
        }

        if (!isNull(object.value)) {
            this._value = ContentFactory.getContentFromObject(object.value, this._languagePack);
            delete object.value;
        }

        this._variable = object.variable;
        delete object.variable;

        this._scores = [];
        numScores = object.scores.length;
        for (index = 0; index < numScores; index++) {
            this._scores.push(new MCOptionScore(object.scores[index].variable, object.scores[index].addition));
        }
        delete object.scores;

        // Call Super
        super.setPropertiesFromObject(object);
    }

    // TODO: implement export csv text
    exportText(csv) {
        throw "Export text not implemented";
    }
}